import {ReactComponent} from '../app'
import {Row, Col} from "antd"
import React from "react"
import VOPContent from '../components/parts/VOPContent'
import FixedHeader from '../components/layout/FixedHeader'

export default class VOPPage extends ReactComponent {
  render() {
    return (
      <>
        <FixedHeader/>
        <section className="container full-height centered simple-text-page">
          <Row align="center" justify="center" gutter={[20, 20]}>
            <Col span={24}>

              <VOPContent />

            </Col>
          </Row>
        </section>
      </>

    )
  }
}